import React from "react";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { FaGithub, FaLinkedin } from "react-icons/fa";

function SocialMedia() {
  return (
    <div className="app__social">
      <a href="https://twitter.com/" target="blank">
        <div>
          <BsTwitter />
        </div>
      </a>
      <a href="https://www.instagram.com/habibbfr/" target="blank">
        <div>
          <BsInstagram />
        </div>
      </a>
      <a
        href="https://www.linkedin.com/in/habib-fatkhul-rohman/"
        target="blank"
      >
        <div>
          <FaLinkedin />
        </div>
      </a>
      <a href="https://github.com/habibfr" target="blank">
        <div>
          <FaGithub />
        </div>
      </a>
    </div>
  );
}

export default SocialMedia;
